export default __webpack_public_path__ + "static/media/shopee.d6f2d36b.svg";